module.exports = __webpack_public_path__ + "static/media/0.ed1ec006.jpg";